import { render, staticRenderFns } from "./member-list.vue?vue&type=template&id=29535b84"
import script from "./member-list.vue?vue&type=script&lang=js"
export * from "./member-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports